"use client";
import { CLIENT_API_ROUTES } from "@/utils/clientApiRoutes";
import axios from "axios";
import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { FaArrowRight } from "react-icons/fa";

function Service() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const [catRes, serRes] = await Promise.all([
          axios.get(CLIENT_API_ROUTES?.GET_SERVICE_CATEGORIES),
          axios.get(CLIENT_API_ROUTES?.GET_SERVICES),
        ]);

        let categories = catRes?.data?.categories || [];
        let services = serRes?.data?.services || [];

        // Filter categories that have coreService flag true
        categories = categories.filter((cat) => cat?.coreService === true);

        // Get category IDs with coreService: true
        const coreCategoryIds = categories.map((cat) => cat._id);

        // Filter services to only include those whose category is in core categories
        services = services.filter(
          (service) =>
            service?.serviceCategory &&
            coreCategoryIds.includes(service.serviceCategory._id)
        );

        setCategories(categories);
        setServices(services);

        if (categories.length > 0) {
          setSelectedCategory(categories[0]._id);
        } else {
          setSelectedCategory(null);
        }
      } catch (err) {
        console.error("Error Fetching categories and services:", err?.message);
        setCategories([]);
        setServices([]);
        setSelectedCategory(null);
      }
    };

    getData();
  }, []);

  const filteredServices = useMemo(() => {
    if (!selectedCategory || !services?.length > 0) return [];
    return services.filter(
      (service) => service?.serviceCategory?._id === selectedCategory
    );
  }, [services, selectedCategory]);

  return (
    <div className="w-[90%] md:w-[85%] mx-auto my-8 md:my-16">
      {categories?.length > 0 && (
        <p className="text-[#053c63] font-bold text-2xl md:text-3xl">
          Our Services
        </p>
      )}

      <div className="w-full py-2 min-w-[16rem] my-4 md:my-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-center ietms-center gap-2 md:gap-4">
          {categories?.length > 0 &&
            categories?.map((item, i) => (
              <p
                key={i}
                onClick={() => setSelectedCategory(item?._id)}
                className={`p-2 md:p-1 px-4 md:px-6 min-h-[3rem] cursor-pointer text-base md:text-lg font-sans font-semibold flex justify-between items-center rounded-md ${
                  selectedCategory === item?._id
                    ? "bg-[#e5e7eb] text-primary"
                    : "bg-white text-gray-500 "
                } border-[1.2px] shadow-lg border-[#bfdae0] hover:border-[#a7c2c9] hover:scale-[1.02]`}
              >
                {item?.name}
              </p>
            ))}
        </div>
      </div>

      <div className="w-full bg-white grid grid-cols-1 mt-4 md:mt-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-6">
        {filteredServices?.length > 0 &&
          filteredServices.map((item, i) => (
            <div
              key={i}
              className="min-h-[12rem] hover:scale-[1.02] border border-[#bfdae0] bg-[#004d7d0f] p-4 rounded-lg flex flex-col gap-3 "
            >
              <p className="text-lg md:text-xl font-sans text-primary line-clamp-2 font-semibold">
                {item?.title}
              </p>
              <p className="text-[#4E6770] line-clamp-4 text-sm font-medium">
                {item?.description}
              </p>
              <Link href={`/services/${item?.slug}`}>
                <p className="font-sans flex items-center gap-2 text-[#053c63] text-base font-semibold">
                  Learn More <FaArrowRight className="inline text-sm" />{" "}
                </p>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Service;
